module.exports = __webpack_public_path__ + "static/image/font/pc/bmdohyeon-5@3x.ver2_0_2.jpg?f8f53a37";